/*
  Multirow video rows (sections/multirow.liquid): the MP4 URL waits in
  data-near-view-video and is set once the video is within 400px of the
  screen; then it plays muted on loop, and pauses whenever it's farther away.
  If the browser refuses autoplay (e.g. iOS Low Power Mode), the same MP4 is
  shown in an <img>, which Safari plays like a GIF; it loads near view and is
  unloaded farther away (it can't pause). Browsers that can't show an MP4 as an
  image keep the still frame underneath. Nymock addition.
*/
(function () {
  if (window.nymockNearViewVideo) return;
  window.nymockNearViewVideo = true;

  const showAsImage = (video, src) => {
    if (video.dataset.nearViewVideoFallback) return;
    video.dataset.nearViewVideoFallback = 'true';
    const img = new Image();
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.dataset.nearViewVideoImage = src;
    img.onload = () => {
      img.onload = img.onerror = null;
      video.removeAttribute('src');
      video.load();
      observer?.unobserve(video);
      video.replaceWith(img);
      observer?.observe(img);
    };
    img.onerror = () => (img.onload = img.onerror = null);
    img.src = src;
  };

  const play = (video) => {
    const src = video.dataset.nearViewVideo;
    if (src) {
      video.muted = true;
      video.removeAttribute('data-near-view-video');
      video.src = src;
    }
    const playing = video.play();
    if (playing)
      playing.catch((error) => {
        if (error.name === 'NotAllowedError') showAsImage(video, video.getAttribute('src'));
      });
  };

  const onEntry = (entry) => {
    const element = entry.target;
    if (element.tagName === 'IMG') {
      if (entry.isIntersecting) element.src = element.dataset.nearViewVideoImage;
      else element.removeAttribute('src');
    } else if (entry.isIntersecting) play(element);
    else element.pause();
  };

  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => entries.forEach(onEntry), { rootMargin: '400px 0px' })
      : null;

  const watch = (root) =>
    root.querySelectorAll('video[data-near-view-video]').forEach((video) => (observer ? observer.observe(video) : play(video)));

  watch(document);
  document.addEventListener('shopify:section:load', (event) => watch(event.target));
})();
